import React, { useContext, useEffect } from "react";
// Soft UI Dashboard PRO React example components

import Carousel from "components/UpStyled/Carousel";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";

// Overview page components
import Header from "./components/Header";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import Gallery from "pages/ma/profile/components/Gallery";

const Profile = () => {
  const {
    store,
    tags = [],
    retriveStore,
    updateStore,
    listStoreTags,
    addStoreTag,
  } = useContext(StoreContext);

  const account = useContext(AccountContext);

  return (
    <div>
      <SuiBox mb={3}>
        <Header store={store} updateStore={updateStore} editable={false} />
      </SuiBox>
      <SuiBox>
        <Gallery store={store} updateStore={updateStore} editable={false}></Gallery>
      </SuiBox>
    </div>
  );
};

export default Profile;
